var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"success"},on:{"click":_vm.downloadDocument}},[_vm._v(" "+_vm._s(_vm.field.etiqueta)+" "),_c('v-icon',{attrs:{"small":"","right":""}},[_vm._v("fas fa-download")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }